/** @jsx jsx */

import * as React from "react";
import { css, jsx } from "@emotion/core";
import { MAIN_STYLES } from "./styles/main";
import { connect } from "react-redux";
import { Store } from "Store/index";

/** Props used by the Main component for rendering. */
export type MainProps = React.PropsWithChildren<{
  /**
   * Designates which layout should be used when rendering, this appears as a
   * CSS modifier class on the "main" tag.
   */
  layout: "MOBILE" | "TABLET" | "DESKTOP";
}>;

function main(props: MainProps): JSX.Element {
  return (
    <main css={MAIN_STYLES(props.layout)}>
      <div className={`layout layout--${String(props.layout).toLowerCase()}`}>
        {props.children}
      </div>
    </main>
  );
}

const mainMemo = React.memo<MainProps>(main);

function computeLayout(state: Store): MainProps["layout"] {
  let result: MainProps["layout"] = "MOBILE";
  const matches = state.browser.matching_media_queries.map(match => match.id);
  if (matches.includes("720")) result = "TABLET";
  if (matches.includes("1440")) result = "DESKTOP";

  return result;
}

function mapStateToProps(state: Store): Pick<MainProps, "layout"> {
  return {
    layout: computeLayout(state)
  };
}

const mainHOC = connect(mapStateToProps, () => ({}))(mainMemo);
export { mainHOC as Main };
